// @flow
import api from 'tim-api';
import { oldGoals as oldGoalsEndPoint, oldGoalsDownload as downloadGoalsFormer, oldGoalsBU as downloadOldGoalsBu } from 'endPoints';


export const state: Object = {
  listMonths: []
};

export const getters = {
  listMonthsGetter: (state: Object) => state.listMonths
};

export const mutations = {
  SET_LIST_MONTHS(state: Object, listMonths: Array<Object>) {
    state.listMonths = listMonths;
  }
};

export const actions = {
  fetchList({ commit }: Action, page: number) {
    return api.get(oldGoalsEndPoint + '?page=' + page).then(({ data }) => {
      commit('SET_LIST_MONTHS', data);
    });
  },
  downloadOldGoals({ commit }: Action, id: string) {
    return api.get(`${downloadGoalsFormer}${id}`, { responseType: 'blob' })
      .then(({ data }) => data);
  },
  downloadBuOldGoals({ commit }: Action, id: string) {
    return api.get(`${downloadOldGoalsBu}${id}`, { responseType: 'blob' })
      .then(({ data }) => data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
